export default __webpack_public_path__ + "static/favicon-f9181175c323c4ea66e6461343195104.ico";